<template>
    <v-menu 
        v-if="showButton"
        :close-on-content-click="false"
        v-model="fab"
        offset-x offset-y top transition="slide-y-reverse-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
            style="position: fixed; left: 8px; bottom: 8px; z-index: 9999"
            color="black"
            dark
            fab
            v-bind="attrs"
            v-on="on"
        >
            <v-icon>{{fab ? 'mdi-close' : 'mdi-message-outline'}}</v-icon>
        </v-btn>
        <v-snackbar 
            v-model="successSurveyMessage" color="success" top
            timeout="2500" class="pt-8"
        >
            <h3 class="d-flex align-center justify-center">¡Gracias por enviarnos tu opinión!</h3>
        </v-snackbar>
      </template>
      <v-card width="250" class="d-flex flex-column align-center justify-center pa-4">
        <h3>¡Tu opinión importa!</h3>
        <span class="text-center mt-2">Ayúdanos a mejorar tu experiencia respondiendo una breve encuesta.</span>
        <v-btn :to="'/'" color="black" class="mt-2" dark @click="openSurvey">Responder Encuesta</v-btn>
      </v-card>
      <v-dialog v-model="surveyDialog" width="auto" persistent>
            <survey-response
                with-cancel
                :surveyId="surveyId"
                @send="sendSurveyResponse"
                @cancel="cancelSurveyResponse"
            ></survey-response>
        </v-dialog>
    </v-menu>
</template>

<script>
    import SurveyViewConfigProvider from '../../../delivery/providers/SurveyViewConfigProvider'
    import SurveyResponse from '../SurveyResponse'
    // import SurveyResponseProvider from '../../../delivery/providers/SurveyResponseProvider'

    export default {
        name: "SurveyResponseBubble",
        components: {SurveyResponse},
        data: () => ({
            fab: false,
            surveyDialog: false,
            surveyId: '',
            showButton: false,
            successSurveyMessage: false
        }),
        mounted(){
            this.loadSurvey()
        },
        methods: {
            openSurvey(){
                this.surveyDialog = true
                this.fab = false
            },
            async loadSurvey(){
                try {
                    const {data: {fetchSurveyViewConfig}} = await SurveyViewConfigProvider.fetchSurveyViewConfig()
                    const homeView = fetchSurveyViewConfig.find(item => item.view === 'home')
                    if(!homeView) return
                    this.surveyId = homeView.survey.id
                    this.showButton = homeView.enable
                } catch (error) {
                    console.error(error)
                }
            },
            sendSurveyResponse() {
                this.surveyDialog = false
                this.successSurveyMessage = true
            },
            cancelSurveyResponse(){
                this.surveyDialog = false
            }
        }
    }
</script>

<style scoped>

    .v-btn:before {
        background-color: black !important;
        border-radius: inherit;
        bottom: 0;
        color: inherit;
        content: "";
        left: 0;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
    }
</style>